import React from "react"
import { FaBars } from "react-icons/fa"

import classes from "./TopNavigation.module.scss"

const TopNavigation = props => {
  const { setOpenSidebar } = props

  return (
    <div className={classes["container"]}>
      <FaBars
        onClick={() => setOpenSidebar(prev => !prev)}
        className={classes["menu"]}
      />
    </div>
  )
}

export default TopNavigation